
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_18g1h_93",
  "refresh": "awsui_refresh_2qdw9_18g1h_132",
  "root-no-actions": "awsui_root-no-actions_2qdw9_18g1h_132",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_18g1h_135",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_18g1h_135",
  "root-has-description": "awsui_root-has-description_2qdw9_18g1h_135",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_18g1h_144",
  "main": "awsui_main_2qdw9_18g1h_154",
  "no-wrap": "awsui_no-wrap_2qdw9_18g1h_164",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_18g1h_170",
  "actions": "awsui_actions_2qdw9_18g1h_178",
  "actions-centered": "awsui_actions-centered_2qdw9_18g1h_183",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_18g1h_186",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_18g1h_190",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_18g1h_194",
  "title": "awsui_title_2qdw9_18g1h_210",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_18g1h_215",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_18g1h_222",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_18g1h_228",
  "virtual-space": "awsui_virtual-space_2qdw9_18g1h_249",
  "info": "awsui_info_2qdw9_18g1h_255",
  "description": "awsui_description_2qdw9_18g1h_259",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_18g1h_266",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_18g1h_270",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_18g1h_277",
  "heading": "awsui_heading_2qdw9_18g1h_286",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_18g1h_297",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_18g1h_302",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_18g1h_307",
  "heading-text": "awsui_heading-text_2qdw9_18g1h_313",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_18g1h_316",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_18g1h_324",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_18g1h_332",
  "counter": "awsui_counter_2qdw9_18g1h_341"
};
  